export default "__VITE_ASSET__BdBYQ7XJ__"